import axiosInstance from "app/axiosInstance";
import { KeyActionRequestDto } from "../entities/dtos/key-action-request.dto";

export const putKeyInventory = async ({
  accountId,
  keyId
}: KeyActionRequestDto) => {
  try {
    const response = await axiosInstance.post(
      `/accounts/${accountId}/keys/${keyId}/inventory`
    );

    return response;
  } catch (e: any) {
    console.error(e);
    throw e;
  }
};
